var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopPerformer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4411_12489)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4411_12489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H0V10H10V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4411_12489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 6.875V7.75",
    stroke: "#213366",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97852 9.16406H7.14517V8.7474C7.14517 8.28906 6.77017 7.91406 6.31184 7.91406H3.81185C3.35352 7.91406 2.97852 8.28906 2.97852 8.7474V9.16406Z",
    stroke: "#213366",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5625 9.16406H7.56249",
    stroke: "#213366",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9987 6.66536C3.3862 6.66536 2.08203 5.3612 2.08203 3.7487V2.4987C2.08203 1.57786 2.82786 0.832031 3.7487 0.832031H6.2487C7.16953 0.832031 7.91536 1.57786 7.91536 2.4987V3.7487C7.91536 5.3612 6.6112 6.66536 4.9987 6.66536Z",
    stroke: "#213366",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27878 4.85416C1.96628 4.75416 1.69128 4.57083 1.47461 4.35416C1.09961 3.9375 0.849609 3.4375 0.849609 2.85417C0.849609 2.27083 1.30794 1.8125 1.89128 1.8125H2.16211C2.07878 2.00417 2.03711 2.21667 2.03711 2.4375V3.6875C2.03711 4.10417 2.12461 4.49583 2.27878 4.85416Z",
    stroke: "#213366",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7207 4.85416C8.0332 4.75416 8.3082 4.57083 8.52487 4.35416C8.89987 3.9375 9.14987 3.4375 9.14987 2.85417C9.14987 2.27083 8.69154 1.8125 8.1082 1.8125H7.83737C7.9207 2.00417 7.96237 2.21667 7.96237 2.4375V3.6875C7.96237 4.10417 7.87487 4.49583 7.7207 4.85416Z",
    stroke: "#213366",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4411_12489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPerformer);
export default __webpack_public_path__ + "static/media/top-performer.7f46327e5cf817040f6f3797493ccc08.svg";
export { ForwardRef as ReactComponent };